/*const config = {
  API_URL: 'https://commodity-api.sostruckingsoftware.com/api/',
  TENANT_ID: 12,
}*/

const config = {
  API_URL: 'https://rt-api.sostruckingsoftware.com/api/',
  TENANT_ID: 12,
}

/*const config = {
  API_URL: 'https://rt-api-test.sostruckingsoftware.com/api/',
  TENANT_ID: 12,
}*/

/*const config = {
  API_URL: 'http://localhost:63774/api/',
  TENANT_ID: 12,
}*/

export default config;
